<template>
    <CollapsibleWidget :is-opened="isOpened" :collapsed-height="collapsedHeight" @onChange="onInput">
        <template #name>
            <slot name="name" />
        </template>
        <template #controls>
            <slot name="controls-prefix" />
            <Icon
                type="md-apps"
                size="18"
                class="widget-mode"
                :class="{ 'widget-mode--active': !isListMode }"
                @click.stop="toggleMode(false)"
            />
            <Icon
                type="md-list"
                size="18"
                class="widget-mode"
                :class="{ 'widget-mode--active': isListMode }"
                @click.stop="toggleMode(true)"
            />
            <slot name="controls" />
        </template>

        <div class="editable-widget__body">
            <div v-if="readOnly" class="editable-widget__body--readonly" title="Read Only" @click.stop.prevent></div>
            <template v-if="isListMode">
                <slot name="list-view" />
            </template>
            <template v-else>
                <slot name="grid-view" />
            </template>
        </div>
    </CollapsibleWidget>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";

export default defineComponent({
    name: "MultiviewEditableWidget",
    components: { CollapsibleWidget },
    props: {
        isOpened: {
            type: Boolean,
            default: true
        },
        readOnly: {
            type: Boolean
        }
    },

    emits: ["input"],

    data() {
        return {
            isListMode: false
        };
    },

    computed: {
        collapsedHeight() {
            return this.isListMode ? 47 : 139;
        }
    },

    methods: {
        toggleMode(isList: boolean) {
            this.isListMode = isList;
        },

        onInput(val: boolean) {
            this.$emit("input", val);
        }
    }
});
</script>
